// Transaction intent
enum NonTransactionalIntent {
  SEE_ORDERS = 'SEE_ORDERS',
  BROKER_LOGOUT = 'BROKER_LOGOUT',
}

export default NonTransactionalIntent;
